import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { LinearProgress as MuiLinearProgress } from '@mui/material';
import { useTranslation } from '@zurich/common/hooks';
import { styled } from '../../utils';
import { FormGrid } from '../FormGrid';
import { Typography } from '../Typography';
export var StepDirection;
(function (StepDirection) {
    StepDirection["NEXT"] = "next";
    StepDirection["PREV"] = "prev";
    StepDirection["NONE"] = "none";
})(StepDirection || (StepDirection = {}));
// find by id
export const getStepById = (steps, stepId) => {
    const step = steps.find(({ id }) => id === stepId);
    if (step === undefined)
        throw new Error(`There is no Step with id "${stepId}"`);
    return step;
};
export function StepProgress({ activeStepId, stepMax, label, nextLabel, }) {
    const { t } = useTranslation();
    const value = Math.round((activeStepId / stepMax) * 100);
    return (_jsxs(StepProgressStyled, { rowGap: 0.5, children: [_jsx(LabelStyled, { variant: "body2", component: "h4", children: `${t('common:stepper.progress.current')} ${activeStepId}/${stepMax} : ${label}` }), _jsx(SubtitleStyled, { color: "text.secondary", component: "h5", variant: "subtitle2", children: nextLabel && `${t('common:stepper.progress.prev')}: ${nextLabel}` }), _jsxs(LinearProgressContainerStyled, { children: [_jsx(LinearProgressStyled, { variant: "determinate", value: value }), _jsx(Typography, { sx: {
                            flexGrow: 0,
                        }, variant: "body2", color: "text.secondary", children: `${value}%` })] })] }));
}
const StepProgressStyled = styled(FormGrid)(({ theme }) => ({
    padding: theme.spacing(1, 0),
    width: '100%',
}));
const LabelStyled = styled(Typography)(({ theme }) => ({
    fontWeight: theme.typography.fontWeightMedium,
}));
const SubtitleStyled = styled(Typography)(({ theme }) => ({
    fontSize: theme.typography.caption.fontSize,
}));
const LinearProgressStyled = styled(MuiLinearProgress)(({ theme }) => ({
    backgroundColor: theme.palette.white.dark,
    flexGrow: 1,
}));
const LinearProgressContainerStyled = styled('div')(({ theme }) => ({
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(2),
}));
